// extracted by mini-css-extract-plugin
export default {"block2":"hover_block2__KDtjY","block1":"hover_block1__zvhOA"};